import { render, staticRenderFns } from "./o-features-v2.vue?vue&type=template&id=7ce048ca&scoped=true"
import script from "./o-features-v2.vue?vue&type=script&lang=js"
export * from "./o-features-v2.vue?vue&type=script&lang=js"
import style0 from "./o-features-v2.vue?vue&type=style&index=0&id=7ce048ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce048ca",
  null
  
)

export default component.exports